import { useMemo } from 'react';
import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import { useBreakpointContext } from 'EmailEditorUI/components/mo/BreakpointContext';
// @ts-expect-error no declarations found for module
import { getEffectiveStyleSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { useAppSelector } from 'EmailEditorUI/redux';
class StyleSettingKeyPath extends Array {
  toString() {
    return this.join('.');
  }
}
function useStyleSetting(propertyNameOrAlias, {
  breakpointName,
  defaultValue,
  path
} = {}) {
  var _breakpointName;
  const {
    breakpointName: __breakpointNameFromContext
  } = useBreakpointContext();
  (_breakpointName = breakpointName) !== null && _breakpointName !== void 0 ? _breakpointName : breakpointName = __breakpointNameFromContext;
  const propertyPath = useMemo(() => {
    if (Array.isArray(path)) {
      return StyleSettingKeyPath.of(...path);
    }
    if (breakpointName === 'mobile') {
      return StyleSettingKeyPath.of('mobile_settings', propertyNameOrAlias);
    }
    return StyleSettingKeyPath.of(propertyNameOrAlias);
  }, [breakpointName, path, propertyNameOrAlias]);
  const styleSetting = useAppSelector(state => {
    const styleSettings = getEffectiveStyleSettings(state);
    let styleSettingsValue = styleSettings.getIn(propertyPath);
    if (breakpointName === 'mobile' && isNullOrUndefined(styleSettingsValue)) {
      // If `mobile_settings` doesn't have a value, then attempt to inherit from the parent
      styleSettingsValue = styleSettings.getIn(propertyPath.slice(1));
    }
    return styleSettingsValue || defaultValue || '';
  });
  return [styleSetting, {
    propertyPath
  }];
}
export default useStyleSetting;